import React from 'react';
import { Link } from 'react-router-dom';
import { isAuthenticated } from '../services/auth'; // <-- Importar función de autenticación
import '../styles/PoliticaPrivacidad.css';

const PoliticaPrivacidad = () => {
  const userIsAuthenticated = isAuthenticated();

  return (
    <div className="politica-container">
      <div className="politica-card">
        <div className="politica-header">
          <img 
            src="/sinteligen4.png" 
            alt="KleverBotBase" 
            className="politica-logo"
          />
          <h1>Política de Privacidad</h1>
          <p className="politica-fecha">Última actualización: 9 de septiembre de 2026</p>
        </div>

        <div className="politica-content">
          <section>
            <h2>1. Introducción</h2>
            <p>
              En <strong>KleverBotBase</strong> (en adelante, "nosotros", "nuestro" o "la Plataforma"), nos tomamos muy en serio la privacidad de nuestros usuarios. Esta Política de Privacidad explica cómo recopilamos, usamos, divulgamos y protegemos tu información cuando utilizas nuestra plataforma de gestión de citas y comunicación a través de WhatsApp.
            </p>
            <p>
              Al utilizar nuestra Plataforma, aceptas la recopilación y el uso de información de acuerdo con esta política.
            </p>
          </section>

          <section>
            <h2>2. Información que Recopilamos</h2>
            <h3>2.1. Información que nos proporcionas directamente</h3>
            <ul>
              <li><strong>Datos de registro:</strong> Nombre, dirección de correo electrónico, número de teléfono y nombre de la empresa cuando creas una cuenta.</li>
              <li><strong>Datos de perfil:</strong> Información que agregas a tu perfil dentro de la plataforma.</li>
              <li><strong>Contenido de los mensajes:</strong> Los mensajes y archivos que envías y recibes a través de nuestro servicio de WhatsApp.</li>
              <li><strong>Datos de facturación:</strong> Información de pago para procesar suscripciones o compras (si corresponde).</li>
            </ul>

            <h3>2.2. Información recopilada automáticamente</h3>
            <ul>
              <li><strong>Datos de uso:</strong> Cómo interactúas con nuestra plataforma, las páginas que visitas y las funciones que usas.</li>
              <li><strong>Datos del dispositivo:</strong> Dirección IP, tipo de navegador, sistema operativo y otros identificadores técnicos.</li>
              <li><strong>Cookies y tecnologías similares:</strong> Utilizamos cookies para mejorar tu experiencia y analizar el uso de la plataforma.</li>
            </ul>
          </section>

          <section>
            <h2>3. Cómo Usamos tu Información</h2>
            <p>Utilizamos la información recopilada para los siguientes fines:</p>
            <ul>
              <li><strong>Prestar el servicio:</strong> Gestionar tus citas, enviar y recibir mensajes a través de WhatsApp, y proporcionar las funcionalidades de la plataforma.</li>
              <li><strong>Mejorar la plataforma:</strong> Analizar cómo se usa nuestro servicio para optimizar la experiencia del usuario.</li>
              <li><strong>Comunicación:</strong> Enviarte notificaciones sobre tu cuenta, actualizaciones del servicio, y responder a tus consultas.</li>
              <li><strong>Seguridad:</strong> Proteger la integridad de la plataforma y prevenir actividades fraudulentas o no autorizadas.</li>
              <li><strong>Cumplimiento legal:</strong> Cumplir con nuestras obligaciones legales y regulatorias.</li>
            </ul>
          </section>

          <section>
            <h2>4. Compartición de Datos</h2>
            <p>
              No vendemos, alquilamos ni compartimos tu información personal con terceros para sus propios fines de marketing sin tu consentimiento explícito. Podemos compartir tu información en las siguientes circunstancias:
            </p>
            <ul>
              <li><strong>Proveedores de servicios:</strong> Con terceros de confianza que nos ayudan a operar la plataforma (ej. servicios de hosting, procesamiento de pagos, servicios de email).</li>
              <li><strong>Requisitos legales:</strong> Si la ley nos obliga a divulgar información en respuesta a una solicitud gubernamental o legal válida.</li>
              <li><strong>Transferencia de negocio:</strong> En el caso de una fusión, adquisición o venta de activos, tu información podría ser transferida al nuevo propietario.</li>
            </ul>
          </section>

          <section>
            <h2>5. Seguridad de los Datos</h2>
            <p>
              Implementamos medidas de seguridad técnicas, administrativas y físicas para proteger tu información personal contra el acceso no autorizado, la alteración, la divulgación o la destrucción. Sin embargo, ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro, por lo que no podemos garantizar su seguridad absoluta.
            </p>
          </section>

          <section>
            <h2>6. Tus Derechos</h2>
            <p>Dependiendo de tu ubicación, puedes tener ciertos derechos con respecto a tu información personal:</p>
            <ul>
              <li><strong>Acceder:</strong> Solicitar una copia de los datos personales que tenemos sobre ti.</li>
              <li><strong>Rectificar:</strong> Corregir datos incorrectos o incompletos.</li>
              <li><strong>Eliminar:</strong> Solicitar la eliminación de tus datos personales.</li>
              <li><strong>Oponerte:</strong> Oponerte al procesamiento de tus datos para ciertos fines.</li>
              <li><strong>Portabilidad:</strong> Solicitar la transferencia de tus datos a otro proveedor.</li>
            </ul>
            <p>Para ejercer estos derechos, contáctanos a través de <a href="mailto:klever_mix@hotmail.com">klever_mix@hotmail.com</a>.</p>
          </section>

          <section>
            <h2>7. Retención de Datos</h2>
            <p>
              Conservamos tu información personal durante el tiempo que sea necesario para cumplir con los fines descritos en esta política, a menos que la ley exija o permita un período de retención más prolongado. Cuando ya no necesitemos tu información, la eliminaremos de forma segura.
            </p>
          </section>

          <section>
            <h2>8. Enlaces a Terceros</h2>
            <p>
              Nuestra plataforma puede contener enlaces a sitios web o servicios de terceros. Esta Política de Privacidad no se aplica a esos sitios web, y no somos responsables de sus prácticas de privacidad. Te recomendamos leer las políticas de privacidad de cualquier sitio web que visites.
            </p>
          </section>

          <section>
            <h2>9. Cambios a esta Política</h2>
            <p>
              Podemos actualizar esta Política de Privacidad periódicamente. Te notificaremos sobre cualquier cambio publicando la nueva política en esta página y actualizando la fecha de "Última actualización". Te recomendamos revisar esta política regularmente para estar informado sobre cómo protegemos tu información.
            </p>
          </section>

          <section>
            <h2>10. Contacto</h2>
            <p>
              Si tienes preguntas o inquietudes sobre esta Política de Privacidad, o sobre nuestras prácticas de privacidad, puedes contactarnos en:
            </p>
            <ul>
              <li><strong>Correo electrónico:</strong> <a href="mailto:klever_mix@hotmail.com">klever_mix@hotmail.com</a></li>
              <li><strong>Plataforma:</strong> <a href="https://crm.sinteligen.com" target="_blank" rel="noopener noreferrer">https://crm.sinteligen.com</a></li>
            </ul>
          </section>
        </div>

        <div className="politica-footer">
          <Link 
            to={userIsAuthenticated ? "/dashboard" : "/login"} 
            className="politica-back-btn"
          >
            {userIsAuthenticated ? "← Volver al Dashboard" : "← Volver al Login"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidad;